import React, { useState, useEffect } from "react";
import styles from "../assets/css/UserList.module.css";
import { NavLink } from "react-router-dom";
import { Loader } from "../../components/Loader";
import { postData1 } from "../../services";
import { Pagination } from "../Common";
import { nullToEmptyString } from "../../utils/purefun";

// conflict resolved
export const ArrangeDemoList = () => {
  const [requestlistData, setRequestListData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: "id",
    direction: 'asc',
  });
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [query, setQuery] = useState(null)

  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
  };

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const sortedData = React.useMemo(() => {
    let sortedArray = [...requestlistData];
    if (sortConfig.key) {
      sortedArray.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortedArray;
  }, [requestlistData, sortConfig]);

  const filteredData = requestlistData.filter((item) => {
    const q = query ? query.trim().toLowerCase() : "";
    if (!q) return true;

    return (
      (item?.equip_name || "").toLowerCase().includes(q) ||
      (item?.buyer_firstname || "").toLowerCase().includes(q) ||
      (item?.seller_firstname || "").toLowerCase().includes(q) ||
      String(item?.id || "").toLowerCase().includes(q)
    );
  });


  // useEffect(() => {
  //   (async () => {
  //     const config = { _page: currPage, _limit: itemsPerPage  };
  //     const res = await postData1(
  //       "admin/arrange_demo_list/",
  //       config,
  //       true,
  //       true
  //     );
  //     setRequestListData(res?.data?.data);
  //     setPaging({
  //       total: res?.data?.total,
  //       total_pages: res?.data?.total_pages,
  //     });
  //     setLoader(false);
  //   })();
  // }, [currPage, sortConfig, itemsPerPage]);

  useEffect(() => {
    (async () => {
      setLoader(true); // start loading here too
      const config = { _page: currPage, _limit: itemsPerPage };
      const res = await postData1(
        "admin/arrange_demo_list/",
        config,
        true,
        true
      );
      setRequestListData(res?.data?.data || []);
      setPaging({
        total: res?.data?.total || 0,
        total_pages: res?.data?.total_pages || 0,
      });
      setLoader(false);
    })();
  }, [currPage, itemsPerPage]); // Removed sortConfig from here


  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>DEMO REQUEST MANAGEMENT</h1>
        <div className="w-[40%] flex items-center border border-[#019c89] rounded-md px-3 py-1 shadow-sm ">
          <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
          <input
            type="text"
            placeholder="Search by Id, Name, Equip Name"
            className="w-full outline-none bg-transparent text-[#019c89] placeholder-[#019c89]"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>
      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span onClick={() => requestSort('id')}>
            REQUEST ID
            {sortConfig.key === 'id' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span onClick={() => requestSort('created_date')}>
            DATE
            {sortConfig.key === 'created_date' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span onClick={() => requestSort('equip_name')}>
            EQUIPMENT
            {sortConfig.key === 'equip_name' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span onClick={() => requestSort('buyer_firstname')}>
            BUYER
            {sortConfig.key === 'buyer_firstname' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span onClick={() => requestSort('seller_firstname')}>
            SELLER
            {sortConfig.key === 'seller_firstname' ? (
              sortConfig.direction === 'asc' ? ' ↑' : ' ↓'
            ) : null}
          </span>
          <span>DETAIL</span>
        </div>

        {
          filteredData.length > 0 ? (
            filteredData.map((data) => {
              // console.log("demod data", data);
              return (
                <div className={styles.itemData} key={data?.id}>
                  <span>{data?.id}</span>
                  <span>
                    {data?.created_date
                      ? new Date(data.created_date).toDateString()
                      : "N/A"}
                  </span>
                  <span>{data?.equip_name || "N/A"}</span>
                  <span>{`${nullToEmptyString(data?.buyer_firstname)} ${nullToEmptyString(data?.buyer_lastname)}`}</span>
                  <span>{`${nullToEmptyString(data?.seller_firstname)} ${nullToEmptyString(data?.seller_lastname)}`}</span>
                  <span>
                    <NavLink to="demoview/" state={{ item: data }}>
                      View
                    </NavLink>
                  </span>
                </div>
              );
            })
          ) : (
            <div className="flex items-center justify-center text-gray-500 py-4">
              <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
              <span>No results found</span>
            </div>
          )
        }


      </div>
      <Pagination
        total={paging?.total}
        perPage={itemsPerPage}
        setPerPage={setItemsPerPage}
        currPage={currPage}
        prevPage={prevPage}
        tPage={paging?.total_pages}
        updatePage={updatePage}
        setCurrPage={setCurrPage} // Add this prop
      />

      {loader && <Loader />}
    </section>
  );
};
